module.exports = __webpack_public_path__ + "img/corzo-4.dac29404.jpg";